import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles.css';
import { AppRoot } from './app/AppRoot';

createRoot(document.getElementById('root')!).render(<AppRoot />);
